import type { LogoStripBlockPayload } from '@opinix-cloud/shared';

interface TrustStripProps {
  content: LogoStripBlockPayload;
}

export function TrustStrip({ content }: TrustStripProps): JSX.Element {
  return (
    <section className="bg-steel-50 border-y border-steel-200/80">
      <div className="container-x py-10 sm:py-12">
        {content.caption && (
          <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-steel-500">
            {content.caption}
          </p>
        )}
        <ul className="mt-6 flex flex-wrap justify-center gap-x-8 gap-y-3">
          {content.items.map((v) => (
            <li
              key={v}
              className="text-sm font-semibold text-steel-700 tracking-tight"
            >
              {v}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
